import { jsx as _jsx } from "react/jsx-runtime";
import "./MapContextMenu.css";
export const MapContextMenu = ({ items, position, onClose, containerRef }) => {
    if (!position)
        return null;
    return (_jsx("div", { ref: containerRef, className: "map-context-menu", style: { top: position.y, left: position.x }, onClick: (e) => e.stopPropagation(), children: _jsx("ul", { children: Object.keys(items).map((key, index) => (_jsx("li", { onClick: (e) => {
                    onClose();
                    items[key]();
                }, children: key }, index))) }) }));
};
